// src/mixins/analyticsMixin.js
import { analytics } from '../firebase/init';
import { logEvent,setUserProperties } from "firebase/analytics";

export default {
  methods: {
    logEvent(event, params) {
        console.log('陈诚', event, params);
      if (analytics) {
        logEvent(analytics,event, params);
      }
    },
    setUserProperties(params) {
        console.log('设置用户属性', params);
      if (analytics) {
        setUserProperties(analytics,params);
      }
    },
  }
};